import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Translations from '../../providers/i18n';
import './style.scss';

function NavArrow({ className, onClick, i18n }) {
    return (
        <button className={classnames(className, 'nav-arrow')} onClick={() => onClick()}>
            <i className="icn-arrow">
                <div className="tooltip">{i18n.t(`attachments_preview.general.${className === 'left' ? 'previous' : 'next'}`)}</div>
            </i>
        </button>
    );
}

NavArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

NavArrow.defaultProps = {
    className: '',
    onClick: () => null
};

export default Translations.connect(NavArrow);
